export default __webpack_public_path__ + "static/media/12.3.1a.efeb2712.pdf";